import React from "react";
import { Trans, useTranslation } from "react-i18next";
import CloseButton from "./CloseButton";

interface Props {
    title?: string;
    translateTitle?: boolean;
}

const DrawerHeader = ({ title, translateTitle = false }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={`drawer_title`}>
            {translateTitle ? <Trans i18nKey={title} t={t} /> : title}
            <CloseButton />
        </div>
    );
};

export default DrawerHeader;
